module.exports = __webpack_public_path__ + "static/img/special3.62fbb206.png";